import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import PropTypes from 'prop-types';
import constants from '../../../constants';

const ReferralHistory = ({ requestId }) => {
	const referralHistory = useQuery({
		queryKey: ['referral-history', requestId],
		queryFn: async () => {
			// Placeholder for API call to fetch referral history
			const { data } = await axios.get(`/requests/${requestId}/history`);
			return data;
		},
		enabled: !!requestId,
	});
	return (
		<div className="p-4 bg-white rounded">
			<h3>
				<strong>Referral History</strong>
			</h3>
			<table className="table table-zebra table-xs">
				<thead>
					<tr>
						<th>Date</th>
						<th>Receiving Org</th>
						<th>Service</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{referralHistory.data && referralHistory.data.length > 0 ? (
						referralHistory.data.map((referral) => (
							<tr key={`referral-${referral.id}`}>
								<td>{new Date(referral.request_dttm).toLocaleDateString()}</td>
								<td>{referral.agency_name}</td>
								<td>{referral.service}</td>
								<td>{constants.status[referral.request_status]}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="4" className="text-center">
								No referral history available
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

ReferralHistory.propTypes = {
	requestId: PropTypes.number,
};
export default ReferralHistory;
